export const LEAD_FORM_ID = 'lead-form'
export const MODELS_ID = 'modelos'
export const CALCULATOR_ID = 'calculadora'

function scrollTo(id: string): void {
  const el = document.getElementById(id)
  if (!el) return
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  el.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' })
}

/** Smooth-scrolls to the lead form, honoring reduced-motion preferences. */
export function scrollToLeadForm(): void {
  scrollTo(LEAD_FORM_ID)
}

/**
 * "See my options" lands on the model cards, not the form.
 * Browsing first is the lower-commitment step, and picking a card pre-fills the
 * form and scrolls there anyway — so the lead is still captured, just warmer.
 */
export function scrollToModels(): void {
  scrollTo(MODELS_ID)
}

/**
 * The payment hook lands on the estimator, not the form.
 * It promised an answer ("find out what you can pay"), so it has to deliver one
 * before asking for anything. The estimator's own CTA carries them to the form.
 */
export function scrollToCalculator(): void {
  scrollTo(CALCULATOR_ID)
}
